const getters = {
  sidebar: (state) => state.app.sidebar,
  language: (state) => state.app.language,
  size: (state) => state.app.size,
  device: (state) => state.app.device,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  token: (state) => state.user.token,
  introduction: (state) => state.user.introduction,
  roles: (state) => state.user.roles,
  addRouters: (state) => state.permission.addRouters,
  permission_routers: (state) => state.permission.routers,
  routeTo: (state) => state.app.routeTo,
};
export default getters;
